/**
 * HiddenField.tsx
 *
 * A hidden field component that stores values programmatically but does not render
 * any visible UI. These fields are used for:
 * - Storing programmatic values passed from parent applications
 * - Conditional logic that controls visibility of other fields
 * - Passing context between forms in a flow
 *
 * The field stores its value in the form state but renders nothing to the user.
 */

import React from 'react';
import { BaseFieldProps } from './shared/types';

export const HiddenField: React.FC<BaseFieldProps> = ({
  fieldConfig,
  value,
}) => {
  // Hidden fields don't render anything visible
  // The value is stored in the parent form state and used for conditional logic

  // Return null to render nothing
  return null;
};
